import { Button } from '@lokalise/louis'
import { useState } from 'react'
import { UserCreatedProfileModal } from '../UserCreatedProfileModal'

type UserCreatedProfileModalButtonProps = {
  enableEvaluations?: boolean
}

export const UserCreatedProfileModalButton = ({
  enableEvaluations,
}: UserCreatedProfileModalButtonProps) => {
  const [isCreationModalOpen, setIsCreationModalOpen] = useState(false)

  return (
    <>
      <Button onClick={() => setIsCreationModalOpen(true)} variant="primary">
        Create AI profile
      </Button>
      {isCreationModalOpen && (
        <UserCreatedProfileModal
          onClose={() => setIsCreationModalOpen(false)}
          enableEvaluations={enableEvaluations}
        />
      )}
    </>
  )
}
